(function () {
  'use strict';

  /* Mobile-Menü */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Alters-Frage (Kurz-Funnel) */
  var STUFEN = {
    1: { age: '3–5 Jahre', text: 'Für 3–5 Jahre: Starten Sie mit Stufe 1. Sie lesen die Aufgaben vor.' },
    2: { age: '6–8 Jahre', text: 'Für 6–8 Jahre: Starten Sie mit Stufe 2. Ihr Kind liest, Sie begleiten.' },
    3: { age: '9–11 Jahre', text: 'Für 9–11 Jahre: Starten Sie mit Stufe 3. Ihr Kind arbeitet weitgehend selbstständig.' },
    4: { age: '12–14 Jahre', text: 'Für 12–14 Jahre: Starten Sie mit Stufe 4. Eigene Pläne und Reflexion.' }
  };
  function storeGet() { try { return window.localStorage.getItem('lb_age'); } catch (e) { return null; } }
  function storeSet(v) { try { window.localStorage.setItem('lb_age', v); } catch (e) {} }
  function applyAge(picker, age) {
    var info = STUFEN[age];
    picker.querySelectorAll('[data-age]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-age') === String(age) ? 'true' : 'false');
    });
    var res = picker.querySelector('[data-age-result]');
    if (res && info) { res.hidden = false; res.textContent = info.text; }
    picker.querySelectorAll('[data-age-hint]').forEach(function (h) {
      if (info) { h.hidden = false; h.textContent = 'Passt zu Ihrem Kind: Stufe ' + age + ' (' + info.age + ')'; }
    });
  }
  document.querySelectorAll('[data-book-picker]').forEach(function (picker) {
    picker.querySelectorAll('[data-age]').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = b.getAttribute('data-age'); storeSet(a); applyAge(picker, a);
      });
    });
    var saved = storeGet();
    if (saved && STUFEN[saved]) applyAge(picker, saved);
  });

  /* Produktseite: Galerie, Varianten, Sticky-CTA */
  document.querySelectorAll('[data-product-section]').forEach(function (sec) {
    var thumbs = sec.querySelectorAll('[data-thumb]');
    var slides = sec.querySelectorAll('[data-slide]');
    function show(i) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === String(i)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(i)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-thumb')); }); });

    var form = sec.querySelector('[data-product-form]');
    var jsonEl = sec.querySelector('[data-variants]');
    if (form && jsonEl) {
      var variants = [];
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
      var currency = sec.getAttribute('data-currency') || 'CHF';
      var money = function (cents) {
        try { return new Intl.NumberFormat('de-CH', { style: 'currency', currency: currency }).format(cents / 100); }
        catch (e) { return currency + ' ' + (cents / 100).toFixed(2); }
      };
      var idInput = form.querySelector('[data-variant-id]');
      var buttons = sec.querySelectorAll('[data-buy-now],[data-add-cart],[data-sticky-buy]');
      var buyLabel = sec.querySelector('[data-buy-label]');
      var priceWrap = sec.querySelector('[data-price]');
      var stickyPrice = sec.querySelector('[data-sticky-price]');
      var soldOut = (buyLabel && buyLabel.getAttribute('data-sold')) || 'Ausverkauft';
      var original = buyLabel && buyLabel.textContent.trim() !== soldOut ? buyLabel.textContent : 'Jetzt kaufen';
      form.addEventListener('change', function () {
        var selected = [];
        form.querySelectorAll('[data-option-index]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); selected.push(c ? c.value : null);
        });
        var match = variants.find(function (v) {
          return selected.every(function (val, i) { return val === null || v.options[i] === val; });
        });
        if (!match) return;
        idInput.value = match.id;
        buttons.forEach(function (b) { b.disabled = (match.available === false); });
        if (buyLabel) buyLabel.textContent = (match.available === false) ? soldOut : (original || 'Jetzt kaufen');
        var fmt = money(match.price);
        if (priceWrap) {
          var now = priceWrap.querySelector('.price-now'); if (now) now.textContent = fmt;
          var cmp = priceWrap.querySelector('.price-compare');
          if (cmp) { cmp.textContent = match.compare_at_price > match.price ? money(match.compare_at_price) : ''; }
        }
        if (stickyPrice) stickyPrice.textContent = fmt;
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', u.toString());
        }
      });
    }

    var sticky = sec.querySelector('[data-sticky-cta]');
    var target = sec.querySelector('[data-buy-buttons]');
    if (sticky && target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0 ? true : false;
      }, { threshold: 0 }).observe(target);
    }
  });

  /* Warenkorb: Menge ändern aktualisiert automatisch */
  document.querySelectorAll('[data-cart-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var f = inp.closest('form'); if (f) f.submit();
    });
  });

  /* ---------- Warenkorb-Schublade & Ajax-Kauf ---------- */
  var R = window.themeRoutes || { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartJs: '/cart.js', checkout: '/checkout', root: '/' };
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = R.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var panel = drawer.querySelector('.drawer-panel'); if (panel) panel.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function refreshDrawer() {
    return fetch(R.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-inner]');
        var cur = drawer.querySelector('[data-drawer-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var c = drawer.querySelector('[data-drawer-count]');
        if (c) setCount(parseInt((c.textContent.match(/\d+/) || [0])[0], 10));
      });
  }
  function showError(form, msg) {
    var el = form.querySelector('[data-form-error]') || (form.parentElement && form.parentElement.querySelector('[data-form-error]'));
    if (!el) { el = document.createElement('p'); el.className = 'form-error'; el.setAttribute('role', 'alert'); form.insertAdjacentElement('afterend', el); el.setAttribute('data-form-error', ''); }
    el.hidden = !msg; el.textContent = msg || '';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form], .quick-buy')) return;
    if (!window.fetch) return; /* Fallback: normaler Formular-Versand */
    var idEl = form.elements['id']; if (!idEl || !idEl.value) return;
    e.preventDefault();
    var submitter = e.submitter || form.querySelector('[type=submit]');
    var mode = submitter && submitter.value === '/checkout' ? 'checkout' : 'cart';
    var qtyEl = form.elements['quantity'];
    var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
    showError(form, '');
    if (submitter) submitter.classList.add('is-loading');
    fetch(R.cartAdd, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idEl.value, 10), quantity: qty }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { showError(form, res.d.description || res.d.message || 'Das Produkt konnte nicht hinzugefügt werden.'); return; }
        if (mode === 'checkout') { window.location.href = R.checkout; return; }
        return refreshDrawer().then(function () {
          return fetch(R.cartJs, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
        }).then(openDrawer);
      })
      .catch(function () {
        /* Bei Netzwerk-Problemen klassisch absenden */
        form.submit();
      })
      .then(function () { if (submitter) submitter.classList.remove('is-loading'); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cart-open],[data-drawer-close],[data-qty-change]') : null;
    if (!t) return;
    if (t.hasAttribute('data-cart-open')) { if (drawer) { e.preventDefault(); refreshDrawer().then(openDrawer); } return; }
    if (t.hasAttribute('data-drawer-close')) { e.preventDefault(); closeDrawer(); return; }
    if (t.hasAttribute('data-qty-change')) {
      e.preventDefault();
      var inner = drawer && drawer.querySelector('[data-drawer-inner]'); if (inner) inner.classList.add('drawer-loading');
      fetch(R.cartChange, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: t.getAttribute('data-key'), quantity: parseInt(t.getAttribute('data-qty'), 10) })
      }).then(function (r) { return r.json(); })
        .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); return refreshDrawer(); })
        .then(function () { if (inner) inner.classList.remove('drawer-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

})();
